import { createAsyncReducer } from '../../standard-actions/';
import {
    ILoadServiceRequestsCategoriesCountAction,
    ILoadServiceRequestsCategoriesCountSuccessAction,
    ILoadServiceRequestsCategoriesCountErrorAction
} from '../actions/load-categories-count';
import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';

export type ServiceRequestsAction
    = ILoadServiceRequestsCategoriesCountAction
    | ILoadServiceRequestsCategoriesCountSuccessAction
    | ILoadServiceRequestsCategoriesCountErrorAction;

const init = (state: IServiceRequestsState, action: ServiceRequestsAction) => {
    return ({
        ...state,
        requestsCategory: {
            ...initialState.requestsCategory,
            status: action.status,
        }
    })
};

const success = (state: IServiceRequestsState, action: ServiceRequestsAction) => {
    return ({
        ...state,
        requestsCategory: {
            ...initialState.requestsCategory,
            categoryCount: (action as ILoadServiceRequestsCategoriesCountAction).data.categoryCount,
            status: action.status,
            items: (action as ILoadServiceRequestsCategoriesCountAction).data.items
        }
    })
};

const failure = (state: IServiceRequestsState, action: ServiceRequestsAction) => ({
    ...state,
    requestsCategory: {
        ...initialState.requestsCategory,
        status: action.status,
        error: (action as ILoadServiceRequestsCategoriesCountErrorAction).error
    }
});

export const serviceRequestsCategoriesCountReducer = createAsyncReducer(initialState, init, success, failure);
